// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unsubscribe-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f6f6f6;
  padding: 24px;
  font-family: 'Geist Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.unsubscribe-card {
  max-width: 440px;
  width: 100%;
  background: #ffffff;
  border: 1px solid #cfd3d8;
  border-radius: 12px;
  padding: 32px;
  text-align: center;
}

.unsubscribe-logo {
  font-size: 18px;
  font-weight: 600;
  color: #0b0c0f;
  margin-bottom: 24px;
}

.unsubscribe-title {
  font-size: 22px;
  font-weight: 600;
  color: #0b0c0f;
  margin: 0 0 12px;
}

.unsubscribe-message {
  color: rgba(11, 12, 15, 0.72);
  font-size: 15px;
  line-height: 1.5;
  margin: 0 0 24px;
}

.unsubscribe-error {
  color: #d32f2f;
}

.unsubscribe-home-link {
  display: inline-block;
  background: #c07b42;
  color: #041c12;
  padding: 10px 20px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
}

.unsubscribe-home-link:hover {
  opacity: 0.9;
}
`, "",{"version":3,"sources":["webpack://./src/UnsubscribePage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,oFAAoF;AACtF;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".unsubscribe-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f6f6f6;\n  padding: 24px;\n  font-family: 'Geist Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n.unsubscribe-card {\n  max-width: 440px;\n  width: 100%;\n  background: #ffffff;\n  border: 1px solid #cfd3d8;\n  border-radius: 12px;\n  padding: 32px;\n  text-align: center;\n}\n\n.unsubscribe-logo {\n  font-size: 18px;\n  font-weight: 600;\n  color: #0b0c0f;\n  margin-bottom: 24px;\n}\n\n.unsubscribe-title {\n  font-size: 22px;\n  font-weight: 600;\n  color: #0b0c0f;\n  margin: 0 0 12px;\n}\n\n.unsubscribe-message {\n  color: rgba(11, 12, 15, 0.72);\n  font-size: 15px;\n  line-height: 1.5;\n  margin: 0 0 24px;\n}\n\n.unsubscribe-error {\n  color: #d32f2f;\n}\n\n.unsubscribe-home-link {\n  display: inline-block;\n  background: #c07b42;\n  color: #041c12;\n  padding: 10px 20px;\n  border-radius: 8px;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.unsubscribe-home-link:hover {\n  opacity: 0.9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
